// import media files

// import avatar images
import Avatar1 from 'assets/images/avatar/avatar-1.jpg';
import Avatar2 from 'assets/images/avatar/avatar-2.jpg';
import Avatar3 from 'assets/images/avatar/avatar-3.jpg';
import Avatar4 from 'assets/images/avatar/avatar-4.jpg';
import Avatar5 from 'assets/images/avatar/avatar-5.jpg';
import Avatar6 from 'assets/images/avatar/avatar-6.jpg';
import Avatar7 from 'assets/images/avatar/avatar-7.jpg';
import Avatar9 from 'assets/images/avatar/avatar-9.jpg';
import Avatar10 from 'assets/images/avatar/avatar-10.jpg';

// import courses images
import LaravelCourse from 'assets/images/course/course-laravel.jpg';
import GatsbyCourse from 'assets/images/course/course-gatsby.jpg';
import JavaScriptCourse from 'assets/images/course/course-javascript.jpg';
import NodeCourse from 'assets/images/course/course-node.jpg';
import ReactCourse from 'assets/images/course/course-react.jpg';
import AngularCourse from 'assets/images/course/course-angular.jpg';
import GraphQLCourse from 'assets/images/course/course-graphql.jpg';
import HTMLCourse from 'assets/images/course/course-html.jpg';

export const allcourses = [
	{
		id: 1,
		image: GatsbyCourse,
		title: 'Revolutionize how you build the web',
		date_added: 'Added on 7 July, 2020',
		instructor_name: 'Jenny Wilson',
		instructor_image: Avatar7,
		status: 'Pending',
		action: 2,
		level: 'Beginner',
		duration: '1h 46m',
		rating: 4.0,
		ratingby: 9300
	},
	{
		id: 2,
		image: GraphQLCourse,
		title: 'Guide to Static Sites with Gatsby',
		date_added: 'Added on 6 July, 2021',
		instructor_name: 'Brooklyn Simmons',
		instructor_image: Avatar6,
		status: 'Pending',
		action: 2,
		level: 'Beginner',
		duration: '1h 46m',
		rating: 4.0,
		ratingby: 7800
	},
	{
		id: 3,
		image: HTMLCourse,
		title: 'The Modern HTML Courses',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Miston Wilson',
		instructor_image: Avatar5,
		status: 'Pending',
		action: 2,
		level: 'Beginner',
		duration: '1h 46m',
		rating: 4.0,
		ratingby: 8245
	},
	{
		id: 4,
		image: JavaScriptCourse,
		title: 'Courses JavaScript Heading Title',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Guy Hawkins',
		instructor_image: Avatar1,
		status: 'Live',
		action: 1,
		level: 'Beginner',
		duration: '1h 46m',
		rating: 4.0,
		ratingby: 3245
	},
	{
		id: 5,
		image: NodeCourse,
		title: 'Get Start with Node Heading Title',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Sina Ray',
		instructor_image: Avatar3,
		status: 'Live',
		action: 1
	},
	{
		id: 6,
		image: LaravelCourse,
		title: 'Get Start with Laravel',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Sobo Rikhan',
		instructor_image: Avatar9,
		status: 'Live',
		action: 1,
		level: 'Intermediate',
		duration: '3h 56m',
		rating: 4.0,
		ratingby: 5300
	},
	{
		id: 7,
		image: ReactCourse,
		title: 'Get Start with React',
		date_added: 'Added on 4 July, 2021',
		instructor_name: 'April Noms',
		instructor_image: Avatar2,
		status: 'Live',
		action: 1,
		level: 'Intermediate',
		duration: '2h 46m',
		rating: 4.0,
		ratingby: 9300
	},
	{
		id: 8,
		image: AngularCourse,
		title: 'Get Start with Angular',
		date_added: 'Added on 3 July, 2021',
		instructor_name: 'Jacob Jones',
		instructor_image: Avatar4,
		status: 'Pending',
		action: 2,
		level: 'Intermediate',
		duration: '1h 30m',
		rating: 4.0,
		ratingby: 5568
	},
	{
		id: 9,
		image: LaravelCourse,
		title: 'Get Start with Laravel',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Sobo Rikhan',
		instructor_image: Avatar9,
		status: 'Live',
		action: 1,
		level: 'Intermediate',
		duration: '2h 30m',
		rating: 4.0,
		ratingby: 6245
	},
	{
		id: 10,
		image: NodeCourse,
		title: 'Get Start with Node Heading Title',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Sina Ray',
		instructor_image: Avatar3,
		status: 'Live',
		action: 1,
		level: 'Advance',
		duration: '2h 30m',
		rating: 4.0,
		ratingby: 6245
	},
	{
		id: 11,
		image: JavaScriptCourse,
		title: 'Courses JavaScript Heading Title',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Guy Hawkins',
		instructor_image: Avatar10,
		status: 'Live',
		action: 1,
		level: 'Advance',
		duration: '1h 30m',
		rating: 4.0,
		ratingby: 5568
	},
	{
		id: 12,
		image: LaravelCourse,
		title: 'Get Start with Laravel',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Sobo Rikhan',
		instructor_image: Avatar9,
		status: 'Live',
		action: 1,
		level: 'Advance',
		duration: '2h 46m',
		rating: 4.0,
		ratingby: 9300
	},
	{
		id: 13,
		image: ReactCourse,
		title: 'Get Start with React',
		date_added: 'Added on 4 July, 2021',
		instructor_name: 'April Noms',
		instructor_image: Avatar2,
		status: 'Live',
		action: 1,
		level: 'Advance',
		duration: '2h 46m',
		rating: 4.0,
		ratingby: 9300
	},
	{
		id: 14,
		image: AngularCourse,
		title: 'Get Start with Angular',
		date_added: 'Added on 3 July, 2021',
		instructor_name: 'Jacob Jones',
		instructor_image: Avatar4,
		status: 'Pending',
		action: 2,
		level: 'Advance',
		duration: '2h 46m',
		rating: 4.0,
		ratingby: 9300
	},
	{
		id: 15,
		image: GatsbyCourse,
		title: 'Revolutionize how you build the web',
		date_added: 'Added on 7 July, 2020',
		instructor_name: 'Jenny Wilson',
		instructor_image: Avatar7,
		status: 'Pending',
		action: 2,
		level: 'Advance',
		duration: '2h 46m',
		rating: 4.0,
		ratingby: 9300
	},
	{
		id: 16,
		image: GraphQLCourse,
		title: 'Guide to Static Sites with Gatsby',
		date_added: 'Added on 6 July, 2021',
		instructor_name: 'Brooklyn Simmons',
		instructor_image: Avatar6,
		status: 'Pending',
		action: 2,
		level: 'Advance',
		duration: '2h 46m',
		rating: 4.0,
		ratingby: 9300
	},
	{
		id: 17,
		image: AngularCourse,
		title: 'Get Start with Angular',
		date_added: 'Added on 3 July, 2021',
		instructor_name: 'Jacob Jones',
		instructor_image: Avatar4,
		status: 'Pending',
		action: 2,
		level: 'Advance',
		duration: '2h 46m',
		rating: 4.0,
		ratingby: 9300
	},
	{
		id: 18,
		image: LaravelCourse,
		title: 'Get Start with Laravel',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Sobo Rikhan',
		instructor_image: Avatar9,
		status: 'Live',
		action: 1,
		level: 'Advance',
		duration: '2h 46m',
		rating: 4.0,
		ratingby: 9300
	},
	{
		id: 19,
		image: NodeCourse,
		title: 'Get Start with Node Heading Title',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Sina Ray',
		instructor_image: Avatar3,
		status: 'Live',
		action: 1,
		level: 'Advance',
		duration: '2h 46m',
		rating: 4.0,
		ratingby: 9300
	},
	{
		id: 20,
		image: JavaScriptCourse,
		title: 'Courses JavaScript Heading Title',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Guy Hawkins',
		instructor_image: Avatar10,
		status: 'Live',
		action: 1,
		level: 'Intermediate',
		duration: '2h 46m',
		rating: 4.0,
		ratingby: 9300
	}
];

export const allapprovedcourses = [
	{
		id: 4,
		image: JavaScriptCourse,
		title: 'Courses JavaScript Heading Title',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Guy Hawkins',
		instructor_image: Avatar1,
		status: 'Live',
		action: 1
	},
	{
		id: 5,
		image: NodeCourse,
		title: 'Get Start with Node Heading Title',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Sina Ray',
		instructor_image: Avatar3,
		status: 'Live',
		action: 1
	},
	{
		id: 6,
		image: LaravelCourse,
		title: 'Get Start with Laravel',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Sobo Rikhan',
		instructor_image: Avatar9,
		status: 'Live',
		action: 1
	},
	{
		id: 7,
		image: ReactCourse,
		title: 'Get Start with React',
		date_added: 'Added on 4 July, 2021',
		instructor_name: 'April Noms',
		instructor_image: Avatar2,
		status: 'Live',
		action: 1
	},
	{
		id: 9,
		image: LaravelCourse,
		title: 'Get Start with Laravel',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Sobo Rikhan',
		instructor_image: Avatar9,
		status: 'Live',
		action: 1
	},
	{
		id: 10,
		image: NodeCourse,
		title: 'Get Start with Node Heading Title',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Sina Ray',
		instructor_image: Avatar3,
		status: 'Live',
		action: 1
	},
	{
		id: 11,
		image: JavaScriptCourse,
		title: 'Courses JavaScript Heading Title',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Guy Hawkins',
		instructor_image: Avatar10,
		status: 'Live',
		action: 1
	},
	{
		id: 12,
		image: LaravelCourse,
		title: 'Get Start with Laravel',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Sobo Rikhan',
		instructor_image: Avatar9,
		status: 'Live',
		action: 1
	},
	{
		id: 13,
		image: ReactCourse,
		title: 'Get Start with React',
		date_added: 'Added on 4 July, 2021',
		instructor_name: 'April Noms',
		instructor_image: Avatar2,
		status: 'Live',
		action: 1
	},
	{
		id: 18,
		image: LaravelCourse,
		title: 'Get Start with Laravel',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Sobo Rikhan',
		instructor_image: Avatar9,
		status: 'Live',
		action: 1
	},
	{
		id: 19,
		image: NodeCourse,
		title: 'Get Start with Node Heading Title',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Sina Ray',
		instructor_image: Avatar3,
		status: 'Live',
		action: 1
	},
	{
		id: 20,
		image: JavaScriptCourse,
		title: 'Courses JavaScript Heading Title',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Guy Hawkins',
		instructor_image: Avatar10,
		status: 'Live',
		action: 1
	}
];

export const allpendingcourses = [
	{
		id: 1,
		image: GatsbyCourse,
		title: 'Revolutionize how you build the web',
		date_added: 'Added on 7 July, 2020',
		instructor_name: 'Jenny Wilson',
		instructor_image: Avatar7,
		status: 'Pending',
		action: 2
	},
	{
		id: 2,
		image: GraphQLCourse,
		title: 'Guide to Static Sites with Gatsby',
		date_added: 'Added on 6 July, 2021',
		instructor_name: 'Brooklyn Simmons',
		instructor_image: Avatar6,
		status: 'Pending',
		action: 2
	},
	{
		id: 3,
		image: HTMLCourse,
		title: 'The Modern HTML Courses',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Miston Wilson',
		instructor_image: Avatar5,
		status: 'Pending',
		action: 2
	},
	{
		id: 8,
		image: AngularCourse,
		title: 'Get Start with Angular',
		date_added: 'Added on 3 July, 2021',
		instructor_name: 'Jacob Jones',
		instructor_image: Avatar4,
		status: 'Pending',
		action: 2
	},
	{
		id: 14,
		image: AngularCourse,
		title: 'Get Start with Angular',
		date_added: 'Added on 3 July, 2021',
		instructor_name: 'Jacob Jones',
		instructor_image: Avatar4,
		status: 'Pending',
		action: 2
	},
	{
		id: 15,
		image: GatsbyCourse,
		title: 'Revolutionize how you build the web',
		date_added: 'Added on 7 July, 2020',
		instructor_name: 'Jenny Wilson',
		instructor_image: Avatar7,
		status: 'Pending',
		action: 2
	},
	{
		id: 16,
		image: GraphQLCourse,
		title: 'Guide to Static Sites with Gatsby',
		date_added: 'Added on 6 July, 2021',
		instructor_name: 'Brooklyn Simmons',
		instructor_image: Avatar6,
		status: 'Pending',
		action: 2
	},
	{
		id: 17,
		image: AngularCourse,
		title: 'Get Start with Angular',
		date_added: 'Added on 3 July, 2021',
		instructor_name: 'Jacob Jones',
		instructor_image: Avatar4,
		status: 'Pending',
		action: 2
	},
	{
		id: 18,
		image: LaravelCourse,
		title: 'Get Start with Laravel',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Sobo Rikhan',
		instructor_image: Avatar9,
		status: 'Pending',
		action: 1
	},
	{
		id: 19,
		image: NodeCourse,
		title: 'Get Start with Node Heading Title',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Sina Ray',
		instructor_image: Avatar3,
		status: 'Pending',
		action: 1
	},
	{
		id: 20,
		image: JavaScriptCourse,
		title: 'Courses JavaScript Heading Title',
		date_added: 'Added on 5 July, 2021',
		instructor_name: 'Guy Hawkins',
		instructor_image: Avatar10,
		status: 'Pending',
		action: 1
	}
];
export const AllCoursesData = [
	allcourses,
	allapprovedcourses,
	allpendingcourses
];

export default AllCoursesData;
